var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_002-whatsapp",
    "data-name": "002-whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.312,
    height: 42.312,
    viewBox: "0 0 42.312 42.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M21.156,0A21.16,21.16,0,0,0,3.2,32.354C2.368,35.282.858,40.82.842,40.877a.814.814,0,0,0,1.024.991l8.386-2.579A21.157,21.157,0,1,0,21.156,0Zm0,40.684A19.48,19.48,0,0,1,10.8,37.714a.814.814,0,0,0-.432-.124.827.827,0,0,0-.239.036L2.8,39.88c.538-1.963,1.5-5.475,2.065-7.429a.817.817,0,0,0-.1-.668,19.53,19.53,0,1,1,16.387,8.9Z",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M36.716,27.962c-1.5-.834-2.781-1.671-3.714-2.281-.713-.465-1.228-.8-1.605-.991a1.849,1.849,0,0,0-2.16.153.814.814,0,0,0-.1.124c-1.1,1.644-2.527,3.217-2.946,3.3a19.593,19.593,0,0,1-5-3.239c-2.3-1.916-3.746-3.751-3.959-5,1.475-1.518,2.007-2.474,2.007-3.561,0-1.12-2.614-5.8-3.086-6.271s-1.543-.548-3.176-.222a.822.822,0,0,0-.416.222c-.2.2-4.824,4.915-2.626,10.632C12.344,27.1,18.539,34.4,26.436,35.58a17.114,17.114,0,0,0,2.527.2c4.646,0,7.388-2.338,8.16-6.975A.81.81,0,0,0,36.716,27.962ZM26.678,33.971c-8.352-1.252-13.612-9.527-15.228-13.727-1.6-4.166,1.353-7.881,2.1-8.72a6.137,6.137,0,0,1,1.5-.1,29.223,29.223,0,0,1,2.557,5.048c0,.427-.139,1.022-1.8,2.679a.81.81,0,0,0-.238.575c0,4.26,8.986,10.171,10.578,10.171,1.384,0,3.189-2.326,4.217-3.842a.772.772,0,0,1,.3.094c.293.147.8.478,1.443.9.848.554,1.974,1.29,3.3,2.052C34.812,32,33.124,34.939,26.678,33.971Z",
    transform: "translate(-1.74 -1.821)",
    fill: "#f2025d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9ec40bf5a81db376e2b6ff0fd8bceff5.svg";
export { ForwardRef as ReactComponent };